import React, { Component } from 'react';
import { connect } from 'react-redux';
import Account from './account';
import Personal from './personal';
import General from './general';
import Notification from './notification';
import Security from './security';
import Api from './api';
import LoginHistory from './loginhistory';
import Sessions from './sessions';
import Loader from '../../components/loader';
import Modal from '../../components/modal';
import ToastHandler from '../../components/toasthandler';

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalComponent: null,
      wideModal: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal(component, wideModal) {
    this.setState({
      modalComponent: component,
      wideModal: wideModal,
    });
  }

  render() {
    const { user, errors, success } = this.props;

    if (!user) {
      return (
        <div className="center-loader">
          <Loader logo />
        </div>
      );
    }

    // const isVerified = user && user.me && user.me.flags && user.me.flags.verified;

    return (
      <div className="grid-x">
        <ToastHandler errors={errors} success={success} />
        {this.state.modalComponent &&
          <Modal noclose={user.resetCode} toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} wideModal={this.state.wideModal} />
        }
        <Account toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} />
        <Personal toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} />
        <General toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} />
        <Notification toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} />
        <Security toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} />
        <Api toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  success: state.user.success,
});

export default connect(mapStateToProps)(Settings);
